require('../vendor/fslightbox/fslightbox');

if(typeof(document.querySelector('[data-fslightbox="gallery"]')) != 'undefined' && document.querySelector('[data-fslightbox="gallery"]') != null) {
    let iframePlayers = {};

    fsLightboxInstances['gallery'].props.slideshowTime = 1000;

    function callPlayer(iframe, func, args) {
        iframe = document.getElementById(iframe);
        let event = "command";
        if (func.indexOf('get') > -1) {
            event = "listening";
        }

        if (iframe && iframe.src.indexOf('youtube.com/embed') !== -1) {
            iframe.contentWindow.postMessage(JSON.stringify({
                'event': event,
                'func': func,
                'args': args || []
            }), '*');
        }
    }

    window.onmessage = function (e) {
        let data = JSON.parse(e.data);
        data = data.info;
    }

    function manageAutoplay() {
        // create all unique iframes if not exist
        fsLightbox.elements.sources.forEach((source, index) => {
            if (source.tagName !== 'IFRAME') {
                return;
            }

            if (fsLightbox.stageIndexes.current === index) {
                if (!iframePlayers[source.id]) {
                    // console.log('create iframe for id: ' + source.id);
                    iframePlayers[source.id] = document.getElementById(source.id);
                    iframePlayers[source.id].addEventListener("load", function() {
                        callPlayer(source.id, 'playVideo');
                    });
                }
            } else {
                iframePlayers[source.id].addEventListener("load", function() {
                    callPlayer(source.id, 'stopVideo');
                });
            }
        });

        // stop all iframePlayers
        // console.log('loop and stop iframePlayers');
        _.each(iframePlayers, function (value, id) {
            callPlayer(id, 'stopVideo');
        });

        // start current
        fsLightbox.elements.sources.forEach((source, index) => {
            if (source.tagName !== 'IFRAME') {
                return;
            }

            if (fsLightbox.stageIndexes.current === index) {
                callPlayer(source.id, 'playVideo');
            } else {
                callPlayer(source.id, 'stopVideo');
            }
        });
    }

    document.addEventListener('DOMContentLoaded', function () {
        fsLightboxInstances['gallery'].props.onOpen = manageAutoplay;
        fsLightboxInstances['gallery'].props.onSlideChange = manageAutoplay;
    });
}
